import type {
  IOnboardingGetApprovalStatusParams,
  IOnboardingGetApprovalStatusRequest,
  IOnboardingGetApprovalStatusResponse,
} from '@/app-package';

import axios from 'axios';

// @TODO: Move this enum to users package
enum VerificationStatus {
  unsent = 'unsent',
  pending = 'pending',
  success = 'success',
}

const getApprovalStatus = async ({
  orgClaimHash,
  verifyHash,
}: IOnboardingGetApprovalStatusParams) => {
  const url = `brokerage_setup/get_approval_status/${orgClaimHash}?verifyHash=${verifyHash}`;

  const config: IOnboardingGetApprovalStatusRequest = { url, method: 'get' };

  const { data } =
    await axios.request<IOnboardingGetApprovalStatusResponse>(config);

  return { ...data, status: data.status as VerificationStatus };
};

export default getApprovalStatus;
